const organicChecklist_processing = [
    {
        "category": "01",
        "chineseText": "1.基本資料",
        "englishText": "1.General Information",
        "chineseDisplay": "基本資料",
        "englishDisplay": "General Information",
        "items": [
            {
                "code": "01-1",
                "chineseText": "1.1 申請者是否擁有一份本公司現行的有機標準？",
                "englishText": "1.1 Does the applicant have a current Organic Standards applied for?"
            },
            {
                "code": "01-2",
                "chineseText": "1.2 查驗過程中，受訪人是否全程在場？姓名及職稱。",
                "englishText": "1.2 Was the owner/manager/organic contact person present during the entire inspection? Person(s)name and job title。"
            },
            {
                "code": "01-3",
                "chineseText": "1.3 有機加工分裝流通驗證申請書“ （以下簡稱「申請書」）第一節”是否填寫完整與正確？如“否”，請描述任何的改變。",
                "englishText": "1.3 Is the “General Information” Section 1 of the Organic System Plan (hereafter refer to as OSP) complete and accurate? If not, please describe any change."
            },
            {
                "code": "01-4",
                "chineseText": "1.4 經營者所提之營登、加工/分裝廠地址是否如實？加工/分裝廠所有權人或使用權人與經營者之關係為何？必要時請提供相關證明文件。",
                "englishText": "1.4 Is the business registration and processing/packing factory address provided by the operator true? " +
                    "What is the relationship between the owner/user of the processing/packing factory  and the operator? Please provide relevant documents if necessary."
            },
            {
                "code": "01-5",
                "chineseText": "1.5 您是否查驗所有的廠房設施、設備與器具？如“否”，請說明您有那些沒有檢查。",
                "englishText": "1.5 Were all facilities and equipment inspected? If no, explain what was not inspected."
            },
            {
                "code": "01-6",
                "chineseText": "1.6 該經營體之週邊生產環境條件是否符合相關規定?",
                "englishText": "1.6 Does the environment around the plant of the operator comply with relevant regulations?"
            },
            {
                "code": "01-7",
                "chineseText": "1.7 該經營者之前曾向其他的驗證機構申請此次的有機標準驗證嗎？若是，為那家驗證機構？申請結果？",
                "englishText": "1.7 Has the operation ever applied to another organic certification agency for the organic standard they applied?" +
                    "If yes, please note which agency and the result of the application？"
            },
            {
                "code": "01-8",
                "chineseText": "1.8 除了目前所申請的標準外，申請者是否同時申請或已通過其它有機標準？如有，請說明。",
                "englishText": "1.8 Besides the standard is applying for, does the applicant also have applied for or certified by other organic standards? If yes, please describe."
            },
            {
                "code": "01-9",
                "chineseText": "1.9 如先前曾被任何機構否決、暫停或吊銷驗證，或曾收到違規通知，該經營者是否提供相關的矯正改善計劃及文件？如“否”，請詳細說明。",
                "englishText": "1.9 If the entity  previously applied to another certifying agent, and has any resulting notices of noncompliance, or denial of certification； " +
                    "are all corrective actions and documentation disclosed in the Plan? If not, please describe."
            },
            {
                "code": "01-10",
                "chineseText": "1.10 除有機加工、分裝及流通作業外，該經營者是否也從事非有機的加工、分裝及流通作業？如“是”，請列出所有非有機產品的名稱。",
                "englishText": "1.10 Is the entity engaged in the processing or handling for both  organic and nonorganic products? If yes, list all nonorganic products"
            },
            {
                "code": "01-11",
                "chineseText": "1.11 經營者是否生產/製造有機轉型期之產品？ (適用台灣標準) 如“是”，請說明產品名稱",
                "englishText": "1.11 Does the operator produce products of  organic in conversion? (For Taiwan standard only) If yes, please list the prodcuts name."
            },
            {
                "code": "01-12",
                "chineseText": "1.12 經營業者是否有非自行操作之部分？如“是”，請說明該合作者(個人或機構)之姓名或名稱。",
                "englishText": "1.12 Does the operator have a part that is not self-operating?If yes, please state the name or name of the partner (individual or organization)?"
            },
            {
                "code": "01-13",
                "chineseText": "1.13 請列出過去三年內（含）未曾生產之驗證產品名稱，以做為延續該產品驗證資格之參考依據。（適用台灣標準）",
                "englishText": "1.13 Please list the name of certified products that have not been produced in the past three years (including) as the basis for continuing the certification of the product. (For Taiwan standard only)"
            },
            {
                "code": "01-14",
                "chineseText": "1.14 請列出此次未生產，但有“申請驗證之有機產品”原料與核對結果（如原料有效期限、批號等是否ok…）。(如原料無庫存則無須填寫) ",
                "englishText": "1.14 List all ingredients not processed/handled during inspection and specify the results (ex. materials expiration date, lot number. ...etc) (If the raw materials are not in inventory, not need to fill in)"
            },
            {
                "code": "01-15",
                "chineseText": "1.15 請列出此次查驗生產所使用的原料核對結果（如原料有效期限、批號等是否ok…）。",
                "englishText": "1.15 List all ingredients used during this inspection and specify the results (ex. materials expiration date, lot number. ...etc)"
            },
            {
                "code": "01-16",
                "chineseText": "1.16 第1節其他說明",
                "englishText": "1.16 Additional comments or observations for Section 1"
            },
        ]
    },
    {
        "category": "02",
        "chineseText": "2.標示方法及產品成份",
        "englishText": "2.Labeling and Product Composition",
        "chineseDisplay": "標示方法及產品成份",
        "englishDisplay": "Labeling and Product Composition",
        "items": [
            {
                "code": "02-1",
                "chineseText": "2.1 申請書“第二節”是否填寫完整並符合現行法規？",
                "englishText": "2.1 Is Section 2 (Labeling, Product Composition, By-Products and water) of the OSP complete and in compliance with the regulation?"
            },
            {
                "code": "02-2",
                "chineseText": "2.2 有機產品將以何種名義販售(NOP): “100%有機”, “有機”, “有機成份少於 70% “, “使用有機（特定成分或食物群）”",
                "englishText": "2.2 Are products sold labeled as: “100% organic”, “organic”, “<70% organic ingredients”, “made with organic ingredients”"
            },
            {
                "code": "02-3",
                "chineseText": "2.3 有機產品將以何種名義販售(EU): “有機”",
                "englishText": "2.3 Are products sold labeled as: “organic”"
            },
            {
                "code": "02-4",
                "chineseText": "2.4 有機產品將以何種名義販(TAIWAN): “有機”, “有機轉型期”",
                "englishText": "2.4 Are products sold labeled as: “organic”, “organic in conversion”"
            },
            {
                "code": "02-5",
                "chineseText": "2.5 所提供之有機產品原料明細表填寫是否完整與正確？",
                "englishText": "2.5 Are Organic Product Profiles complete and accurate for all products requested for certification?"
            },
            {
                "code": "02-6",
                "chineseText": "2.6 所有申請驗證的產品標籤是否已隨申請書附上?若否，請檢附標籤或樣張供本公司審核",
                "englishText": "2.6 Were labels for all products requested for certification included in the Application? If not, please attach labels or copies for TOC review."
            },
            {
                "code": "02-7",
                "chineseText": "2.7 是否有“可追溯的批號”管理？請舉例說明一個產品的批號系統並描述其代表意義",
                "englishText": "2.7 Do organic products  bear a traceable lot number or date code?Give an example of the lot numbering system and describe components?"
            },
            {
                "code": "02-8",
                "chineseText": "2.8 標籤上有機標章的設計及使用是否符合相關規定？",
                "englishText": "2.8 On labels, is the organic seal/logo used in compliance with relevant standard/regulation " +
                    "(replicated in form and design, printed legibly and conspicuously, correct color scheme)?"
            },
            {
                "code": "02-9",
                "chineseText": "2.9 在成份敘述中，是否“有機成份”被標示為有機的?",
                "englishText": "2.9 In the ingredient statement on labels, are organic  ingredients identified as “organic”?"
            },
            {
                "code": "02-10",
                "chineseText": "2.10 僅用於運輸或儲存非零售用有機產品之容器(包含外箱)，其標示是否顯示最後組裝驗證成品的處理者之驗證機構名稱及聯絡資訊?",
                "englishText": "2.10 For labeling of nonretail containers(including external carton)used only for shipping or  storage of organic products, is the name and contact information of the final certifying agent displayed?"
            },
            {
                "code": "02-11",
                "chineseText": "2.11 僅用於運輸或儲存非零售用有機產品之容器是否標明該產品之生產批號?",
                "englishText": "2.11 For labeling of nonretail containers used only for shipping or storage of organic products, is the production lot number of the product displayed?"
            },
            {
                "code": "02-12",
                "chineseText": "2.12 是否按重量/容積大小列出產品所含成份，並列出所有添加物全名？",
                "englishText": "2.12 Does the ingredients in the product list by weight/volume size and list the full names of all the additives?"
            },
            {
                "code": "02-13",
                "chineseText": "2.13 標籤之資訊版面上是否顯示“慈心有機驗證”的字樣?（NOP、EU 適用）",
                "englishText": "2.13 On labels, does the phrase ‟Certified Organic by TOC” appear on the information panel?　 (For NOP, EU only)"
            },
            {
                "code": "02-14",
                "chineseText": "2.14 業者於推廣文宣或網站上的驗證標章或標示是否正確?",
                "englishText": "2.14 Is the operator’s promotional information or the certification mark or label published on the website correct?"
            },
            {
                "code": "02-15",
                "chineseText": "2.15 標示為「使用有機製造(特定成分或食物群)」的產品，其主要資訊版面所列成分或食物群是否超過三項? （NOP 適用）?",
                "englishText": "2.15 For organic products labeled “made with organic (specified ingredients or food group(s))”, does the principal display panel list more than 3 organically produced  ingredients or food groups? (For NOP only)"
            },
            {
                "code": "02-16",
                "chineseText": "2.16 有機產品原料明細表所填資料是否與正式生產時的“原物料配料表”符合？如“否”，請加以說明。",
                "englishText": "2.16 Are all ingredients listed in the Organic Product Profile(s) the  same as actual production recipes?"
            },
            {
                "code": "02-16",
                "chineseText": "2.16 原料入庫前是否有做檢查?如“有”，是否做成紀錄？",
                "englishText": "2.16 Are all ingredients inspected before storage?If yes, is inspection record maintained?"
            },
            {
                "code": "02-17",
                "chineseText": "2.17 廠商所提供之原料相關證件（例：有機／非基因）與您現場實際觀察到者（原料包裝袋、標示…）是否一致？",
                "englishText": "2.17 Are the package and label for all ingredients conform to the certification documentation (ex. Organic/non-GMO) provided by applicant?"
            },
            {
                "code": "02-18",
                "chineseText": "2.18 “有機產品原料明細表”中所有列為「有機」的原料皆保有相關之有機證件?",
                "englishText": "2.18 Is the certification documentation maintained for all ingredients  listed as “organic” on the Organic Product Profile(s)?"
            },
            {
                "code": "02-19",
                "chineseText": "2.19 對於標示為 “有機”的產品，如有使用非有機農產品原料時，是否確認業者保有‟有機原料市面無法獲得”的相關文件?",
                "englishText": "2.19 For “organic” products, is “commercial availability” documentation maintained for all nonorganic agricultural ingredients"
            },
            {
                "code": "02-20",
                "chineseText": "2.20 該有機產品的同一種原料中是否混合使用有機和非有機來源者？",
                "englishText": "2.20 For “100% organic” and “organic” products, does the finished products not include organic and nonorganic forms of the same ingredient?"
            },
            {
                "code": "02-21",
                "chineseText": "2.21 非有機原料(農產與非農產)是否符合相關有機標準的規定?",
                "englishText": "2.21 Are the use of nonorganic ingredients (agricultural and nonagricultural) complying with annotations or restrictions of the relevant organic standard?"
            },
            {
                "code": "02-22",
                "chineseText": "2.22 食品添加物及其他可用物質是否是否符合相關有機標準的規定?",
                "englishText": "2.22 Are the use of additives and other substances complying with the relevant organic standard?"
            },
            {
                "code": "02-23",
                "chineseText": "2.23 副產品是否以“經有機驗證”名義販售? 如是，請列出所有產品名稱?",
                "englishText": "2.23 Are by-products sold as certified organic? If yes, please list product name."
            },
            {
                "code": "02-24",
                "chineseText": "2.24 標示為“100%有機”及“有機”的產品，是否在生產或處理過程使用亞硫酸塩、硝酸塩、亞硝酸塩？ (NOP 適用）如是，請列出使用亞硫酸塩、硝酸塩、亞硝酸塩的所有有機產品",
                "englishText": "2.24 For “100% organic” and “organic” products, are sulfites, nitrates, or nitrites added during the production or handling process? (For NOP only)" +
                    "If yes, list all organic products produced with sulfites, nitrates, or nitrites."
            },
            {
                "code": "02-25",
                "chineseText": "2.25 製程中是否用到水（包含原料、加工助劑、烹煮、冷却、消毒、清洗器具設備等）？如是，請說明用途。",
                "englishText": "2.25 Is water used anywhere in the facility (as on ingredient, processing aid, cooking, cooling, sanitation, cleaning equipment, etc.)? If yes, please describe use."
            },
            {
                "code": "02-26",
                "chineseText": "2.26 請說明製程用水來源: “自來水”, “地下水”, “其他(請說明)“. 若使用自來水，請直接跳答29題",
                "englishText": "2.26 Please describe the source of water: “running water“, “ground water”, “”other(specify). If running water used, please skip to #29"
            },
            {
                "code": "02-27",
                "chineseText": "2.27 製程用水是否符合當地政府的飲用水水質標準？",
                "englishText": "2.27 Does water meet the Safe Drinking Water Quality Standards of local government?"
            },
            {
                "code": "02-28",
                "chineseText": "2.28 非使用自來水者（如地下水或山泉水）是否有淨水處理？如“是”，請說明如何處理？ 生產期間是否每日測定有效餘氯量及酸鹼值？（適用台灣標準）",
                "englishText": "2.28 Is water been treated if non-running water used (such as groundwater or spring water)?" +
                    "Is the effective chlorine residue and pH tested daily during production? (For Taiwan standard only)"
            },
            {
                "code": "02-29",
                "chineseText": "2.29 使用非自來水於食品加工製程時，是否每年檢送經政府或本公司認可之檢驗機構檢驗？如是，水質檢驗報告影本是否已附上。",
                "englishText": "2.29 If water other than running water is used in the processing (as ingredient, contacts with organic products or used for sanitation), is water inspected annually by an authorized testing agencies?" +
                    "If yes, is the copy of test report attached?"
            },
            {
                "code": "02-30",
                "chineseText": "2.30 製程中是否使用蒸汽？",
                "englishText": "2.30 Is steam used in the processing or handling of organic products?"
            },
            {
                "code": "02-31",
                "chineseText": "2.31 製程中蒸汽是否直接接觸到有機產品？如“是”，所用物質是否符合標準？",
                "englishText": "2.31 Does steam come in direct contact with organic products?If yes, does substances used in boiler comply with the standard?"
            },
            {
                "code": "02-30",
                "chineseText": "2.30 第2節其他說明？",
                "englishText": "2.30 Additional comments or observations for Section 2"
            },
        ]
    },
    {
        "category": "03",
        "chineseText": "3.有機完整性的確保",
        "englishText": "3.Assurance of Organic Integrity and Process Management",
        "chineseDisplay": "有機完整性的確保",
        "englishDisplay": "Assurance of Organic Integrity and Process Management",
        "items": [
            {
                "code": "03-1",
                "chineseText": "3.1 有機加工分裝流通驗證申請書第三節是否填寫完整與正確？ 如“否”，請說明有何不同？",
                "englishText": "3.1 Is Section 3, the “Assurance of Organic Integrity and Process Management” of the Organic Handling Plan complete and accurate? If not please describe any changes."
            },
            {
                "code": "03-2",
                "chineseText": "3.2 產品正式生產流程圖是否正確與完整？如“否”，請加以說明。流程中是否列出維護“有機完整性”的危害控制點？",
                "englishText": "3.2 Is the product flow chart accurate and complete? If no, describe product flow. If yes, are the organic critical control points indicated?"
            },
            {
                "code": "03-3",
                "chineseText": "3.3 該經營者是否如實執行【有機完整性說明】（例如：指出潛在性混染及∕或污染的關鍵點）？如“否”，請加以說明。",
                "englishText": "3.3 Does the organic integrity program has been implemented to address areas of potential commingling and/or contamination? If not, please describe."
            },
            {
                "code": "03-4",
                "chineseText": "3.4 產品的召回計劃是否適當？",
                "englishText": "3.4 Is a product recall system in place?"
            },
            {
                "code": "03-5",
                "chineseText": "3.5 於製程中是否有相關之管制標準？（例如：溫度、濕度、pH、水活性……）其他說明。",
                "englishText": "3.5 In the process of manufacturing, if there are relevant control standards? (Ex: temperature, humidity, pH, water activity ... .. ）Other description."
            },
        ]
    },
    {
        "category": "04",
        "chineseText": "4.有害生物防治",
        "englishText": "4.Pest Management",
        "chineseDisplay": "有害生物防治",
        "englishDisplay": "Pest Management",
        "items": [
            {
                "code": "04-1",
                "chineseText": "4.1 有機加工分裝流通驗證申請書“第四節”是否填寫完整與正確？",
                "englishText": "4.1 Is section 4 (Pest Management) complete and accurate in the Plan?"
            },
            {
                "code": "04-2",
                "chineseText": "4.2 請說明業者採行了哪些有害防治措施? 這些措施是否符合相關有機標準的規定?",
                "englishText": "4.2 Please describe which practice have adopted for pest control by the operator? " +
                    "Whether these measures compliant with the relevant organic standards?"
            },
        ]
    },
    {
        "category": "05",
        "chineseText": "5.建立文件",
        "englishText": "5.Record Keeping",
        "chineseDisplay": "建立文件",
        "englishDisplay": "Record Keeping",
        "items": [
            {
                "code": "05-1",
                "chineseText": "5.1 有機加工分裝流通驗證申請書“第四節”是否填寫完整與正確？",
                "englishText": "5.1 Is section 5 (Record Keeping) complete and accurate in the Plan?"
            },
            {
                "code": "05-2",
                "chineseText": "5.2 是否保有進料紀錄，如購物訂單、提單、過磅單據、收據、發票、進貨批號和有機證件等？",
                "englishText": "5.2 Do purchased incoming ingredient records include purchase orders, bills of lading, weight/scale tickets, receipts, " +
                    "incoming lot numbers and organic certification documentation?"
            }
        ]
    },
    {
        "category": "06",
        "chineseText": "6.標章之使用",
        "englishText": "6.Organic Seal",
        "chineseDisplay": "標章之使用",
        "englishDisplay": "Organic Seal",
        "items": [
            {
                "code": "06-1",
                "chineseText": "6.1 產品銷售有否使用標章?",
                "englishText": "6.1 Is the organic seal used in product sales?"
            },
            {
                "code": "06-2",
                "chineseText": "6.2 是否正確使用有機、轉型期之標章?",
                "englishText": "6.2 Is the organic, organic in conversion seal correctly used?"
            }
        ]
    },
    {
        "category": "07",
        "chineseText": "7.確認與採樣",
        "englishText": "7.Affirmation and Sampling",
        "chineseDisplay": "確認與採樣",
        "englishDisplay": "Affirmation and Sampling",
        "items": [
            {
                "code": "07-1",
                "chineseText": "7.1 經營者是否清楚明白且如實執行有機計畫？",
                "englishText": "7.1 Did the applicant demonstrate a comprehensive understanding of and commitment to the organic standards?"
            },
            {
                "code": "07-2",
                "chineseText": "7.2 經營者是否提供所有查驗相關廠區與紀錄資訊？",
                "englishText": "7.2 Did the processor provide access to all areas and records relevant to the inspection?"
            }
        ]
    },
    {
        "category": "08",
        "chineseText": "8.機密性、簽署及附件",
        "englishText": "8.Confidentiality, Signature, and Attachments",
        "chineseDisplay": "機密性、簽署及附件",
        "englishDisplay": "Confidentiality, Signature, and Attachments",
        "items": [
            {
                "code": "08-1",
                "chineseText": "8.1 本人聲明與受驗單位無利益衝突，對於查驗之行為，絕不要求或收受賄賂，或其他不正當利益。",
                "englishText": "8.1 I do not have an interest of conflicts with those of the above clients, I also vouch to the fact that " +
                    "the inspection does not involve in accepting any bribes or other improper benefits."
            },
            {
                "code": "08-2",
                "chineseText": "8.2 本人對於產品驗證過程中所有查證之相關文件、生產、供應商等資訊，絕不洩漏予與驗證無關之第三者。",
                "englishText": "8.2 The information gained in the course of certification activities about a particular product or supplier shall not be disclosed to a third-party, " +
                    "this report is confidential among inspectors, TOC and its accreditors."
            }
        ]
    }
]

export default organicChecklist_processing